module.exports = __webpack_public_path__ + "static/media/history.d69410ae.svg";